import { getTrailerRequestStatusEffect } from '@/redux/Savers/SaversEffects';
import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const TrailerStatusSelector = ({ placeholder, id, onChange, className, mode, value }) => {
  const [options, setOptions] = useState([]);
  const { selectedCompany } = useSelector((state) => state.auth);

  useEffect(() => {
    getUserList();
  }, [selectedCompany]);

  const getUserList = async () => {
    try {
      const { data } = await getTrailerRequestStatusEffect();
      const options = data.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      }));
      setOptions(options);
    } catch (error) {
      console.log(error, 'error');
      setOptions([]);
    }
  };

  return (
    <Select
      id={id}
      mode={mode}
      value={value || null}
      className={className}
      placeholder={placeholder}
      onChange={onChange}
      options={options}
    />
  );
};

export default TrailerStatusSelector;
